import React, { SVGProps } from "react";

type DoubleLineMenuProps = SVGProps<SVGSVGElement>;

export const SmallSingleArrowLine = (props: DoubleLineMenuProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2929 11.074L8.35343 6.1345C8.25836 6.04326 8.1317 5.9923 7.99993 5.9923C7.86816 5.9923 7.7415 6.04326 7.64643 6.1345L2.70993 11.071L2.00293 10.364L6.93943 5.4275C7.22524 5.15476 7.60512 5.00259 8.00018 5.00259C8.39524 5.00259 8.77512 5.15476 9.06093 5.4275L13.9999 10.367L13.2929 11.074Z"
      fill="currentColor"
    />
  </svg>
);
